module.exports = __webpack_public_path__ + "static/media/twitter.6cf85da1.svg";